<script>
  import NumberText from './NumberText/index.svelte';

  export let showParagraph = false;

  const randomIntFromInterval = (min, max) => { // min and max included 
    return Math.floor(Math.random() * (max - min + 1) + min)
  }

  const ranges = [
    [ 11, 100 ],
    [ 101, 1000 ],
    [ 1001, 10000 ],
    [ 10001, 100000 ],
    [ 100001, 1000000 ],
    [ 1000001, 10000000 ],
    [ 10000001, 100000000 ]
  ];

  const genNumbers = () => ranges.map(([ start, end ]) => randomIntFromInterval(start, end));

  let numbers = genNumbers();

  let timeLeft = 20;

  setInterval(() => {
    timeLeft--;
    if (timeLeft == 0) {
        numbers = genNumbers();
        timeLeft = 20;
        return;
    }
  }, 1000);
</script>

{#if showParagraph}
    <h2>Other Numbers</h2>
{:else}
    <h3>Other Numbers</h3>
{/if}
{#if showParagraph}
    <p>If you don't have an idea where to start, try checking out one of these random numbers.</p>
    <br />
{/if}
<ul>
    {#each numbers as number}
        <li>
        <NumberText info = {[ number ]} />
        </li>
    {/each}
</ul>
<h4>Refreshes in {timeLeft}s</h4>